import { isTrialPromotion } from '@/hooks/purchase/purchase';

/**
 * Truemed charges list price, so a coupon or a price-changing promotion on the host form would
 * silently not apply. Trial promotions are fine: the trial is sent with the Truemed checkout.
 * `coupon` is the value the form sends, where the `freetrial` pseudo-coupon is already null.
 */
export const hasTruemedIncompatiblePromo = ({
	coupon,
	promotion,
}: {
	coupon?: string | null;
	promotion?: string | null;
}): boolean => Boolean(coupon) || (!!promotion && !isTrialPromotion(promotion));
